// removed by extract-text-webpack-plugin
module.exports = {"item":"_1bdz2xzWsbKzUtOMvIw0DK","key":"ZAmF6Pwu_An-Vdv7FEzPJ","value":"_3BlDDFwSAk5eWkeyo1TVmW","spin":"_1I9jeaByLyG104SYSDJ_tZ"};


//////////////////
// WEBPACK FOOTER
// ./src/topic/Announcements/components/KeyValueList/styles.scss
// module id = 1660
// module chunks = 18